export default __webpack_public_path__ + "static/media/011-weekly-calendar.c257913d.png";